import { ClientTypeE } from './../../../models/enums';

const getUserType = (clientType: ClientTypeE) => {
    let type = '';

    switch (clientType) {
        case ClientTypeE["Advertising Agency"]: return type = 'adv';
        case ClientTypeE.Broadcaster: return type = 'brd';
        case ClientTypeE["Post/sound production"]: return type = 'pst';
    }
    return type;
};

export default getUserType;